import { Dispatch } from 'redux';
import Storage from '../../common/services/Storage';
import { STORAGE } from '../../Config';
import { UserProfile } from '../../api/account/models/UserProfile';
import { SET_AUTHENTICATION, SET_PROFILE, UPDATE_REFRESH_TOKEN, SET_COMPANY_INFO_FILLED, SET_POLICIES_CHANGED } from './type';
import { UserToken } from 'api/account/models/UserToken';
import i18n from 'common/services/I18n';
import Logger from 'common/services/Logger';
import { DISMISSED_STORAGE_KEY } from 'common/components/announcements/AnnouncementsProvider';

export const initAuthentication = (cb: (rt: boolean) => void) => async (dispatch: Dispatch) => {
	try {

		const profile = Storage.getObject(STORAGE.AUTH_USER_PROFILE);
		const token = Storage.getObject(STORAGE.AUTH_USER_TOKEN);

		if (!profile || !token) {
			cb(false);
			return;
		}

		i18n.changeLanguage(profile.languageCode);
		Logger.setUserProfile(profile);

		dispatch(setAuthentication(profile, token));

		cb(true);
	} catch (ex) {
		dispatch(logout() as any);
		cb(false);
	}
}

export const authenticateUser = (profile: UserProfile, token: UserToken) => async (dispatch: Dispatch) => {
	Storage.setObject(STORAGE.AUTH_USER_PROFILE, profile);
	Storage.setObject(STORAGE.AUTH_USER_TOKEN, token);
	Storage.setObject(STORAGE.CURRENT_LOCALE, profile.languageCode);
	try { localStorage.removeItem(DISMISSED_STORAGE_KEY); } catch { /* ignore */ }
	i18n.changeLanguage(profile.languageCode);
	Logger.setUserProfile(profile);

	dispatch(setAuthentication(profile, token));
}

export const logout = () => async (dispatch: Dispatch) => {
	Storage.remove(STORAGE.AUTH_USER_TOKEN);
	Storage.remove(STORAGE.AUTH_USER_PROFILE);
	Logger.setUserProfile(null);
	dispatch(setAuthentication(null, null));
}

export const setCompanyInfo = (profile: UserProfile | null) => async (dispatch: Dispatch) => {
	Storage.setObject(STORAGE.AUTH_USER_PROFILE, profile);	
	dispatch(setCompanyInfoFilled(profile)); 
}

export const setCompanyInfoFilled = (profile: UserProfile | null) => ({
	type: SET_COMPANY_INFO_FILLED,
	profile
});

export const setAuthentication = (profile: UserProfile | null, token: UserToken | null) => ({
	type: SET_AUTHENTICATION,
	profile,
	token,
});

export const setProfile = (profile: UserProfile | null) => ({
	type: SET_PROFILE,
	profile,
});

export const updateRefreshToken = () => ({
	type: UPDATE_REFRESH_TOKEN,
});

export const setPoliciesChanged = () => ({
	type: SET_POLICIES_CHANGED,
});
